import { updateStoredValues } from '../helpers';
const updateCreditAppDeals = (_ref, walletStorageService) => {
  let {
    types
  } = _ref;
  return payload => async (dispatch, getState) => {
    const isLoggedIn = getState()?.auth?.isLoggedIn || false;
    const paymentsInfo = getState()?.payments;

    // call reducer to merge payload with current state without duplicates
    dispatch({
      type: types.UPDATE_CREDIT_APP_DEALS,
      payload
    });
    // add merged deals to local storage
    const currentDeals = getState()?.payments?.creditAppDeals || [];
    const response = await updateStoredValues({
      paymentsInfo,
      payments: {
        creditAppDeals: currentDeals
      },
      walletStorageService,
      isLoggedIn
    });
    if (!response?.success) {
      dispatch({
        type: types.UPDATE_MY_WALLET,
        payload: {
          displayWalletErrorMessage: true
        }
      });
    }
  };
};
export default updateCreditAppDeals;